import React from 'react';
import {FormikInput} from "presentation/common";
import {formatRut} from "presentation/common/helpers/validate/rut/rut";

export const CommonBillForm = ({name, setFieldValue, setFieldTouched, isRequiredEconomicActivity = true}) => {
  return (
    <>
      <FormikInput
        name={`${name}.rut`}
        label="RUT"
        required
        setFormat={value => {
          setFieldValue(`${name}.rut`, formatRut(value));
          setTimeout(() => setFieldTouched(`${name}.rut`, true, false));
        }}
      />

      <FormikInput
        required
        label="Razón Social"
        name={`${name}.businessType`}/>

      <FormikInput
        required={isRequiredEconomicActivity}
        label="Actividad Económica"
        name={`${name}.economicActivity`}/>
    </>
  );
};
